import * as React from 'react';
import { EventFunc } from 'types/types';
import './IconButton.pcss';

// #bfbfbf

// more_vert
export const IconButton = (props:{onClick?:EventFunc, children:any, big?:boolean, className?:string, disabled?:boolean}) =>
  <a className={`iconBtn noselect${props.big?' big':''} ripple ${props.className?props.className:''}${props.disabled?' disabled':''}`} onClick={(e)=>{ if(!props.disabled && props.onClick) { props.onClick(e); } }}><i className="material-icons">{props.children}</i></a>
;
